import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(theme => ({
    graphContainer: {
        alignItems: 'center',
        display: 'flex',
        height: 'calc(100% - 29px)',
        width: '100%'
    },
    infoButton: {
        padding: '5px',
        position: 'absolute',
        right: '6px',
        top: '6px',
        zIndex: 400
    },
    infoImgContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    infoMainText: {
        fontWeight: 500
    },
    infoSubText: {
        fontStyle: 'italic'
    },
    legend: {
        alignItems: 'center',
        display: 'flex',
        fontSize: '12px',
        fontWeight: '500',
        cursor: 'pointer'
    },
    legendColor: {
        backgroundColor: 'grey',
        height: '10px',
        marginRight: '5px',
        width: '10px'
    },
    legendContainer: {
        display: 'flex',
        flexDirection: 'column',
        height: '80%',
        justifyContent: 'space-around',
        marginLeft: 10,
        width: '50%'
    },
    logoContainer: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-around',
        width: '100%'
    },
    notAllowed: {
        cursor: 'wait',
        opacity: 0.5
    },
    paper: {
        height: '100%',
        width: '100%'
    },
    pieContainer: {
        height: '100%',
        marginRight: 10,
        width: '50%'
    },
    resetButton: {
        padding: '5px',
        position: 'absolute',
        right: '30px',
        top: '6px',
        zIndex: 400
    },
    title: {
        color: theme.palette.grey.ultradark,
        fontSize: '12px',
        fontWeight: '500',
        paddingTop: '10px',
        textAlign: 'center'
    }
}));
